import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Metrics } from "./Metrics";
import { Table } from "./Table";
import { Chart } from "./Chart";
export function Block({ block }) {
    switch (block.type) {
        case "metrics":
            return _jsx(Metrics, { block: block });
        case "table":
            return _jsx(Table, { block: block });
        case "chart":
            return _jsx(Chart, { block: block });
        case "note":
            return (_jsxs("div", { children: [block.title && (_jsx("div", { className: "text-[11px] uppercase tracking-wider text-slate-400 mb-1", children: block.title })), _jsx("p", { className: "text-sm text-slate-300 leading-relaxed", children: block.text })] }));
        default:
            return null;
    }
}
